var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"animated-number-container",class:{ 'no-data': !_vm.displayIsNumber }},[(_vm.displayIsNumber)?[_vm._v(" "+_vm._s(_vm._f("formatNumber")(_vm.display))+" ")]:[_vm._v(" ··· ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }